import { Box } from '@mui/material'
import Stations from '@/features/config/pages/Station/Stations'
import type { GuidedStepComponentProps } from '../guidedSteps'

// SCRUM-1032 / SCRUM-1040 — guided-setup step for Station.
// Embeds the refined station list/edit grid (inline editing + bulk edit +
// column presets), scoped to the setup interface id (never the globally-selected
// interface — SCRUM-976). Stations' `embedded` mode drops the page chrome
// (ConfigLayout offset, ConfigHeader, StatusInterface) so the grid sits directly
// inside the guided-setup panel.
// TODO(SCRUM-1040): add pin-on-map (reuse SetUpThird/components/PinStationsOnMap)
const StationStep = ({
  interfaceId,
  focusMode,
  onToggleFocus,
}: GuidedStepComponentProps) => (
  // A column that owns its height, so the grid scrolls inside the step instead
  // of the step scrolling inside the page — the same shape the decoder step
  // uses. Padding is viewport the grid does not get, so it is only what keeps
  // the list off the wizard chrome.
  <Box
    sx={{
      display: 'flex',
      height: '100%',
      minHeight: 0,
      overflow: 'hidden',
      p: focusMode ? '8px 12px' : '12px 16px',
    }}
  >
    <Stations
      interfaceId={interfaceId}
      embedded
      focusMode={focusMode}
      onToggleFocus={onToggleFocus}
    />
  </Box>
)

export default StationStep
